import { DownloadIcon } from "lucide-react"

import {
  useDocuments,
  type CommonDocument,
} from "@/components/documents/context/DocumentsProvider"
import { DownloadButton } from "@/components/documents/DownloadButton"
import { PreviewDialog } from "@/components/documents/PreviewDialog"

export function CategorizedDocumentsEntry({ doc }: { doc: CommonDocument }) {
  const { DeleteComponent, UncategorizeDocumentComponent } = useDocuments()
  return (
    <div className="flex flex-row items-center justify-between gap-1">
      <span className="truncate text-sm">{doc.typeName}</span>
      <div className="flex flex-none flex-shrink-0 flex-row items-center gap-1">
        <PreviewDialog className="h-4 w-4" doc={doc} />
        {UncategorizeDocumentComponent && (
          <UncategorizeDocumentComponent doc={doc} />
        )}
        <DownloadButton
          aria-label="Download document"
          filename={doc.filename}
          url={doc.downloadUrl}
          title="Download document"
        >
          <DownloadIcon className="text-primary h-4 w-4" />
        </DownloadButton>

        {DeleteComponent && <DeleteComponent doc={doc} className="h-4 w-4" />}
      </div>
    </div>
  )
}
